import { SettingItem } from './index.d';


export const settingList: SettingItem[] = [
  {
    type: 1,
    title: '自定义免打扰',
    desc: '家长可自行设置免打扰时间'
  },
  {
    type: 2,
    title: '学校免打扰',
    desc: '学校为维护课堂秩序设置的免打扰时间'
  }
]